import { render, staticRenderFns } from "./AddEditWorkload.vue?vue&type=template&id=0d22cf8f"
import script from "./AddEditWorkload.vue?vue&type=script&lang=js"
export * from "./AddEditWorkload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports